import Image from "next/image";
import USFlag from "../../public/us.svg";
import EgFlag from "../../public/eg.svg";
import esFlag from "../../public/es.svg";
import frFlag from "../../public/fr.svg";
import ptFlag from "../../public/pt.svg";
import deFlag from "../../public/de.svg";
import itFlag from "../../public/it.svg";

import { SelectItem } from "@/components/ui/select";
import { FaCode, FaLaptopCode, FaReact } from "react-icons/fa";

interface ILang {
  value: string;
  label: string;
  flag: string;
}

export const RenderLang = ({ value, label, flag }: ILang) => {
  return (
    <SelectItem
      className="cursor-pointer rounded-2xl"
      key={value}
      value={value}
    >
      <div className="flex items-center gap-2">
        <Image src={flag} alt="flag" width={20} height={20} sizes="20px" />
        <span>{label}</span>
      </div>
    </SelectItem>
  );
};

export const RenderDefaultLang = (lang: string) => {
  let flag, title;

  switch (lang) {
    case "en":
      flag = USFlag;
      title = "English";
    case "ar":
      flag = EgFlag;
      title = "Arabic";
    case "es":
      flag = esFlag;
      title = "Spanish";
    case "fr":
      flag = frFlag;
      title = "French";
    case "pt":
      flag = ptFlag;
      title = "Portuguese";
    case "de":
      flag = deFlag;
      title = "German";
    case "it":
      flag = itFlag;
      title = "Italian";
    default:
      flag = USFlag;
      title = "English";
  }

  return (
    <div className="flex items-center gap-2">
      <Image
        src={flag}
        alt={title || "flag"}
        width={20}
        height={20}
        sizes="20px"
      />
      <span>{title}</span>
    </div>
  );
};

export const experienceList = [
  {
    id: 1,
    title: "Mid-Level Frontend Developer",
    company: "Alexon Company",
    time: "10/2023 - Present",
    type: "Full-time",
    location: "Onsite",
    address: "Mansoura, Egypt",
    desc: [
      "Built an accounting ERP for 10+ clients, reducing manual accounting errors by 35% and improving workflow efficiency by 40%",
      "Integrated React Query and React Table, reducing API response time by 30% and improving user experience scores by 25%",
    ],
    tech: [
      "ERP Development",
      "React.js",
      "TypeScript",
      "Tailwind CSS",
      "React Query",
      "React Table",
      "React Router",
      "Formik",
    ],
    icon: <FaCode />,
  },
  {
    id: 2,
    title: "Junior Frontend Developer",
    company: "Crete Agency Company",
    time: "07/2024 - 01/2025",
    address: "Cairo, Egypt",
    type: "Part-time",
    location: "Remote",
    desc: [
      "Developed a CRM with real-time data processing, reducing sales reporting errors by 25% and boosting sales team efficiency by 30%",
      "Created responsive, user-friendly interfaces, reducing bounce rates by 20% and increasing session duration by 15%",
    ],
    tech: [
      "CRM Development",
      "React.js",
      "Next.js",
      "Tailwind CSS",
      "TypeScript",
      "React hook form",
    ],
    icon: <FaLaptopCode />,
  },
  {
    id: 3,
    title: "Frontend Developer",
    company: "Ocopus Company",
    time: "07/2023 - 01/2025",
    type: "Part-time",
    location: "Hybrid",
    address: "Mansoura, Egypt",
    desc: [
      "Created new features and optimized performance, reducing page load time by 20%, increasing conversion rates by 12%, and boosting customer retention by 18%",
    ],
    tech: ["React.js", "Next.js", "Tailwind CSS", "TypeScript"],
    icon: <FaReact />,
  },
];
